<template lang="pug">
  base-content(ref="main" title="ライセンス＆サポート購入申請書<span class=\"nopdf\">の作成</span>", :subtitle="subtitle", :type="titleType")
    form(@submit.prevent="submit", data-testid="form-app")
      app-message(v-if="appErrorMessage" type="danger") {{appErrorMessage}}
      app-message(v-if="appInfoMessage" type="info") {{appInfoMessage}}

      button-bar(@downloadDataFile="downloadDataFile" @importData="importData")

      section.section

        form-header(v-if="nextTicker", v-model="postData.application")

        h3#editions.title.required 購入ライセンスエディション

        section.section.checkbox-field(data-testid="editions")
          b-field.required(
            :class="{'unselected': !postData.editions.length || getInputType('editions') === 'is-danger'}"
            :message="getInputMessage('editions')"
            :type="getInputType('editions')"
          )
            section
              .columns.is-multiline(v-if="isEdit")
                .column.is-half(v-for="item in options.editions")
                  b-checkbox(name="editions[]" v-model="postData.editions" :native-value="item.value" :data-testid="item.key") {{item.label}}
                  app-message.nopdf(
                    v-if="postData.editions.indexOf(item.value) >= 0 && item.notesmessage",
                    type="warning"
                  )
                    p(v-html="item.notesmessage")
              template(v-else)
                p(v-for="item in postData.editions") {{getOptionLabelByValue(options.editions, item)}}
              b-field(
                :message="getInputMessage('editions_other')"
                :type="getInputType('editions_other')"
              )
                b-input(
                  v-if="isEdit",
                  v-model="postData.editions_other",
                  name="editions_other",
                  :disabled="!isOptionKeySelected(options.editions, 'otherEdition', postData.editions)",
                  :required="isOptionKeySelected(options.editions, 'otherEdition', postData.editions)",
                  :maxlength="maxlen_lic.editions_other",
                  v-validate="",
                  data-vv-as="その他",
                  placeholder="「その他」を選択した場合、こちらに入力してください。",
                  data-testid="editions_other"
                )
                p(v-else-if="isOptionKeySelected(options.editions, 'otherEdition', postData.editions)") {{postData.editions_other}}
          p.help.is-danger(v-if="!postData.editions.length") 「購入ライセンスエディション」のうち、いずれか一つを選択してください。

        h3#categories.title.required 購入区分詳細

        section.section.checkbox-field(data-testid="categories")
          b-field.required(
            :class="{'unselected': !postData.categories.length || getInputType('categories') === 'is-danger'}"
            :message="getInputMessage('categories')"
            :type="getInputType('categories')"
          )
            section
              .columns.is-multiline(v-if="isEdit")
                .column.is-half(v-for="item in options.categories")
                  b-checkbox(name="categories[]" v-model="postData.categories" :native-value="item.value" @input="handleCategoryChange(item.key)" :data-testid="item.key") {{item.label}}
                    b-tooltip(
                      v-if="item.infoicon === true",
                      :label="item.infomessage",
                      type="is-warning",
                      position='is-top',
                      size="is-large",
                      multilined=''
                    )
                      b-icon(
                        icon='question-circle',
                        type="is-primary",
                        size="is-small"
                      )
                  app-message.nopdf(
                    v-if="postData.categories.indexOf(item.value) >= 0 && item.notesmessage",
                    type="warning",
                  )
                    p {{item.notesmessage}}
                  .field(v-if="item.key === 'yearSupportBuy'")
                    .continue
                      p(:class="{'has-text-grey-light': !isOptionKeySelected(options.categories, 'yearSupportBuy', postData.categories)}") 今回ご購入の年間サポートのサポート期間をお選びください。
                      .block(v-for="item in options.support_continue")
                        b-radio(
                          v-model="postData.support_continue"
                          :key="item.key"
                          name="support_continue"
                          :disabled="!isOptionKeySelected(options.categories, 'yearSupportBuy', postData.categories)"
                          :required="isOptionKeySelected(options.categories, 'yearSupportBuy', postData.categories)"
                          :native-value="item.value"
                          :data-testid="'support_continue-' + item.key"
                        ) {{item.label}}
                            p(v-if="item.key === 'now_continue'").caution ※期間満了前または期間満了後から1年未満のお客様は選択可能です。
                  .field(v-else-if="item.key === 'dndrive'")
                    .continue
                      p(:class="{'has-text-grey-light': !isOptionKeySelected(options.categories, 'dndrive', postData.categories)}")
                        | desknet'sドライブの購入にあたって、以下ライセンス約款を事前にご確認ください。
                        br
                        a(href="https://www.desknets.com/neo/pdf/tac-dndrive.pdf", target="_blank") https://www.desknets.com/neo/pdf/tac-dndrive.pdf
                        br
                        | 申請書をご提出いただいたことで、ライセンス約款に同意いただいたものとさせていただきます。
                        br
                        br
                        | また、ご購入にあたり以下をお選びください。
                      .block
                        p(:class="{'has-text-grey-light': !isOptionKeySelected(options.categories, 'dndrive', postData.categories)}") desknet'sドライブ トライアルを利用していますか。
                        b-field
                          b-radio(v-model="postData.trial_key_usage_flg" name="trial_key_usage_flg" native-value="1" @input="resetDndriveMigration" :disabled="!isOptionKeySelected(options.categories, 'dndrive', postData.categories)" :required="isOptionKeySelected(options.categories, 'dndrive', postData.categories)") はい
                          b-radio(v-model="postData.trial_key_usage_flg" name="trial_key_usage_flg" native-value="0" @input="resetDndriveMigration" :disabled="!isOptionKeySelected(options.categories, 'dndrive', postData.categories)" :required="isOptionKeySelected(options.categories, 'dndrive', postData.categories)") いいえ
                        p(:class="{'has-text-grey-light': !isOptionKeySelected(options.categories, 'dndrive', postData.categories) || postData.trial_key_usage_flg !== '1'}") 本番環境へのデータの引き継ぎを希望しますか。
                        b-field
                          b-radio(v-model="postData.data_migration_request_flg" name="data_migration_request_flg" native-value="1" @input="resetDndriveTrialKey" :disabled="!isOptionKeySelected(options.categories, 'dndrive', postData.categories) || postData.trial_key_usage_flg !== '1'" :required="isOptionKeySelected(options.categories, 'dndrive', postData.categories) && postData.trial_key_usage_flg === '1'") はい
                          b-radio(v-model="postData.data_migration_request_flg" name="data_migration_request_flg" native-value="0" @input="resetDndriveTrialKey" :disabled="!isOptionKeySelected(options.categories, 'dndrive', postData.categories) || postData.trial_key_usage_flg !== '1'" :required="isOptionKeySelected(options.categories, 'dndrive', postData.categories) && postData.trial_key_usage_flg === '1'") いいえ
                        b-field.required(v-if="postData.data_migration_request_flg === '1'" label="desknet'sドライブ トライアルキー")
                          b-input(v-model="postData.trial_key" name="trial_key" :maxlength="maxlen_lic.trial_key" placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" :required="postData.data_migration_request_flg === '1'" v-validate="" data-vv-as="desknet'sドライブ トライアルキー" data-testid="trial_key")
                  .field(v-else-if="item.key === 'appSuiteHandsOnSupport'")
                    .continue
                      p(:class="{'has-text-grey-light': !isOptionKeySelected(options.categories, 'appSuiteHandsOnSupport', postData.categories)}")
                        | AppSuite伴走支援サービスの購入にあたって、以下サービス約款を事前にご確認ください。
                        br
                        a(href="https://www.desknets.com/neo/pdf/article_appsuite_hos.pdf", target="_blank") https://www.desknets.com/neo/pdf/article_appsuite_hos.pdf
                        br
                        | 申請書をご提出いただいたことで、サービス約款に同意いただいたものとさせていただきます。
                        br
                        br
                        | また、ご購入にあたりdesknet's NEOのご利用形態をお選びください。
                      .block(v-for="item in options.service_type")
                        b-radio(
                          v-model="postData.service_type"
                          :key="item.key"
                          name="service_type"
                          :disabled="!isOptionKeySelected(options.categories, 'appSuiteHandsOnSupport', postData.categories)"
                          :required="isOptionKeySelected(options.categories, 'appSuiteHandsOnSupport', postData.categories)"
                          :native-value="item.value"
                        ) {{item.label}}
              template(v-else)
                div(v-for="item in postData.categories")
                  p {{getOptionLabelByValue(options.categories, item)}}
                  .continue(v-if="item === 'o'")
                    p 今回ご購入の年間サポートのサポート期間をお選びください。
                    .block
                      span {{getOptionLabelByValue(options.support_continue, postData.support_continue)}}
                      p(v-if=" postData.support_continue === '0'").caution ※期間満了前または期間満了後から1年未満のお客様は選択可能です。
                  .continue(v-else-if="item === 'r'")
                    p
                      | desknet'sドライブの購入にあたって、以下ライセンス約款を事前にご確認ください。
                      br
                      a(href="https://www.desknets.com/neo/pdf/tac-dndrive.pdf", target="_blank") https://www.desknets.com/neo/pdf/tac-dndrive.pdf
                      br
                      | 申請書をご提出いただいたことで、ライセンス約款に同意いただいたものとさせていただきます。
                    .block
                      p desknet'sドライブ トライアルを利用していますか。
                      p.dndrive-confirm-answer {{postData.trial_key_usage_flg === '1' ? 'はい' : 'いいえ'}}
                      template(v-if="postData.trial_key_usage_flg === '1'")
                        p 本番環境へのデータの引き継ぎを希望しますか。
                        p.dndrive-confirm-answer {{postData.data_migration_request_flg === '1' ? 'はい' : 'いいえ'}}
                      template(v-if="postData.data_migration_request_flg === '1'")
                        p desknet'sドライブ トライアルキー
                        p.dndrive-confirm-answer {{postData.trial_key}}
                  .continue(v-else-if="item === 's'")
                    p
                      | AppSuite伴走支援サービスの購入にあたって、以下サービス約款を事前にご確認ください。
                      br
                      a(href="https://www.desknets.com/neo/pdf/article_appsuite_hos.pdf", target="_blank") https://www.desknets.com/neo/pdf/article_appsuite_hos.pdf
                      br
                      | 申請書をご提出いただいたことで、サービス約款に同意いただいたものとさせていただきます。
                      br
                      br
                    p また、ご購入にあたりdesknet's NEOのご利用形態をお選びください。
                    .block
                      span {{getOptionLabelByValue(options.service_type, postData.service_type)}}
              b-field(
                :message="getInputMessage('categories_other')"
                :type="getInputType('categories_other')"
              )
                b-input(
                  v-if="isEdit",
                  v-model="postData.categories_other",
                  name="categories_other",
                  :disabled="!isOptionKeySelected(options.categories, 'otherCategory', postData.categories)",
                  :required="isOptionKeySelected(options.categories, 'otherCategory', postData.categories)",
                  :maxlength="maxlen_lic.categories_other",
                  v-validate="",
                  data-vv-as="その他",
                  placeholder="「その他」を選択した場合、こちらに入力してください。",
                  data-testid="categories_other"
                )
                p(v-else-if="isOptionKeySelected(options.categories, 'otherCategory', postData.categories)") {{postData.categories_other}}
          p.help.is-danger(v-if="!postData.categories.length") 「購入区分詳細」のうち、いずれか一つを選択してください。

        div(v-show="showAppSuiteSection()" data-testid="section-appsuite")
          h3.title AppSuite 明細
          //- AppSuite
          h4.subtitle 対象エディション：
            span(v-if="isOptionKeySelected(options.editions, 'app', postData.editions)") {{getOptionLabelByKey(options.editions, 'app')}}

            section.section
              b-field.required(
                label="NEO本体保有ライセンス数"
                :message="getInputMessage('as_neo_license_count')"
                :type="getInputType('as_neo_license_count')"
              )
                b-input(
                  v-if="isEdit",
                  v-model="postData.as_neo_license_count",
                  name="as_neo_license_count",
                  :required="showAppSuiteSection()",
                  :maxlength="maxlen_lic.as_neo_license_count",
                  v-validate="",
                  data-vv-as="NEO本体保有ライセンス数",
                  data-testid="as_neo_license_count"
                )
                p(v-else, data-testid="as_neo_license_count") {{postData.as_neo_license_count}}

              app-message.nopdf(type="info")
                p ※ 本ライセンスはdesknet's NEO本体のライセンス数を超える購入および利用はできません。
                p ※ AppSuiteライセンスは、desknet's NEO本体のライセンスを保有されているお客様が購入できるライセンスとなります。

              b-field(
                label="ライセンス証書番号"
                :message="getInputMessage('as_license_no')"
                :type="getInputType('as_license_no')"
              )
                b-input(
                  v-if="isEdit",
                  v-model="postData.as_license_no",
                  name="as_license_no",
                  :maxlength="maxlen_lic.as_license_no",
                  v-validate="",
                  data-vv-as="ライセンス証書番号",
                  :placeholder="lang_field.licenseNoExample"
                  data-testid="as_license_no"
                )

                p(v-else, data-testid="as_license_no") {{postData.as_license_no || '(未入力)'}}

              app-message.nopdf(type='info')
                notice-license-number

        div(v-show="showAddExpensesSection()" data-testid="section-add-expenses")
          h3.title 交通費経費オプション 明細（新規）

          section.section
            b-field.required(
              label="購入区分"
              :message="getInputMessage('add_expenses_category')"
              :type="getInputType('add_expenses_category')"
            )

              template
                b-select(
                  v-if="isEdit"
                  :placeholder="options.add_expenses_category[0].label"
                  v-model="postData.add_expenses_category"
                  name="add_expenses_category",
                  v-validate="",
                  data-vv-as="購入区分",
                  data-testid="add_expenses_category"
                  :required="showAddExpensesSection()"
                )
                  option(v-for="item in options.add_expenses_category" :key="item.key" :value="item.value") {{item.label}}
                p(v-else, data-testid="add_expenses_category") {{getOptionLabelByValue(options.add_expenses_category, postData.add_expenses_category) || '(未選択)'}}

            b-field(
              label="ライセンス証書番号"
              :message="getInputMessage('add_expenses_license_no')"
              :type="getInputType('add_expenses_license_no')"
            )
              b-input(
                v-if="isEdit"
                v-model="postData.add_expenses_license_no"
                name="add_expenses_license_no",
                :maxlength="maxlen_lic.add_expenses_license_no"
                v-validate="",
                data-vv-as="ライセンス証書番号",
                :placeholder="lang_field.licenseNoExample"
                data-testid="add_expenses_license_no"
              )
              p(v-else, data-testid="add_expenses_license_no") {{postData.add_expenses_license_no || '(未入力)'}}

            app-message.nopdf(type='info')
              notice-license-number

            app-message.nopdf(type="warning")
              .content
                p
                  strong 「交通費・経費精算年間ライセンス」オプションのバージョンについて
                p
                  | 「交通費・経費精算年間ライセンス」オプションは、desknet's NEO V3.0以降のオプションライセンスとなります。
                  br
                  | desknet's NEO V2.5以下のバージョンをご利用中のお客様については、V3.0以降にアップデートを実施していただいたうえで本ライセンスをご購入ください。
                p
                  strong desknet's NEOライセンス保有のお客様で「交通費・経費精算年間ライセンス」の購入条件について
                p
                  | 「交通費・経費精算年間ライセンス」の購入については、以下に続くいずれかの条件を満たされている必要がございます。
                  br
                  | (1) desknet's NEOライセンスの新規購入と同時に「交通費・経費精算年間ライセンス」をご購入いただく。
                  br
                  | (2) すでにお持ちのdesknet's NEOライセンスについて、有効期間内の年間サポートを所持されている。
                  br
                  | (3) お客様がすでにお持ちのdesknet's NEOライセンスについて、年間サポートの購入と同時に「交通費・経費精算年間ライセンス」をご購入いただく。
                  br
                p
                  strong ライセンス購入数量について
                p
                  | 「交通費・経費精算年間ライセンス」は原則として単年購入(新規・更新ともに)をお願いしております。
                  br
                  | 複数年契約をご希望の場合は、ネオジャパン営業窓口までご相談ください。

        div(v-show="showUpdExpensesSection()" data-testid="section-upd-expenses")
          h3.title 交通費経費オプション 明細（更新）

          section.section
            b-field.required(
              label="購入区分"
              :message="getInputMessage('upd_expenses_category')"
              :type="getInputType('upd_expenses_category')"
            )
              // TODO '0'ではなくkeyで指定する
              template
                b-select(
                  v-if="isEdit"
                  :placeholder="options.upd_expenses_category[0].label"
                  v-model="postData.upd_expenses_category"
                  name="upd_expenses_category",
                  v-validate="",
                  data-vv-as="購入区分",
                  data-testid="upd_expenses_category"
                  :required="showUpdExpensesSection()"
                )
                  option(v-for="item in options.upd_expenses_category" :key="item.key" :value="item.value") {{item.label}}
                p(v-else, data-testid="upd_expenses_category") {{getOptionLabelByValue(options.upd_expenses_category, postData.upd_expenses_category) || '(未選択)'}}

            b-field.required(
              label="年間サポート証書番号"
              :message="getInputMessage('upd_expenses_support_service_no')"
              :type="getInputType('upd_expenses_support_service_no')"
            )
              b-input(
                v-if="isEdit",
                v-model="postData.upd_expenses_support_service_no",
                name="upd_expenses_support_service_no",
                :required="showUpdExpensesSection()"
                :maxlength="maxlen_lic.upd_expenses_support_service_no",
                v-validate="",
                data-vv-as="年間サポート証書番号",
                placeholder="年間サポート証書番号をご記入ください",
                data-testid="upd_expenses_support_service_no"
              )
              p(v-else, data-testid="upd_expenses_support_service_no") {{postData.upd_expenses_support_service_no}}

        div(v-show="showServerSection()" data-testid="section-server")
          h3.title サーバー動作環境

          section.section
            app-message.nopdf(type='warning')
              ul
                li 構築される環境を選択してください。
                li 動作環境の最新情報は、公式ホームページをご覧ください。
                  a(href='https://www.desknets.com/neo/features/requirement/environment/index.html', target='_blank') https://www.desknets.com/neo/features/requirement/environment/index.html

            //- PDFだけ2列表示になるように組んでいる
            .columns.is-multiline
              .column.is-half-print.is-full-tablet
                b-field(
                  label="DB"
                  :message="getInputMessage('db')"
                  :type="getInputType('db')"
                )
                  b-select(
                    v-if="isEdit"
                    placeholder="（選択してください）"
                    v-model="postData.db"
                    name="db",
                    v-validate="",
                    data-vv-as="DB",
                    data-testid="db"
                  )
                    option(v-for="item in options.db" :value="item.value") {{item.label}}
                  p(v-else, data-testid="db") {{getOptionLabelByValue(options.db, postData.db) || '(未選択)'}}

              .column.is-half-mobile.is-full-tablet
                b-field(
                  label="その他"
                  :message="getInputMessage('db_other')"
                  :type="getInputType('db_other')"
                )
                  b-input(
                    v-if="isEdit"
                    v-model="postData.db_other"
                    name="db_other",
                    :maxlength="maxlen_lic.db_other"
                    v-validate="",
                    data-vv-as="その他のDB",
                    placeholder="その他のDBを入力してください"
                    data-testid="db_other"
                  )
                  p(v-else, data-testid="db_other") {{postData.db_other || '(未入力)'}}

            //- PDFだけ2列表示になるように組んでいる
            .columns.is-multiline
              .column.is-half-print.is-full-tablet
                b-field(
                  label="OS"
                  :message="getInputMessage('os')"
                  :type="getInputType('os')"
                )
                  b-select(
                    v-if="isEdit"
                    placeholder="（選択してください）"
                    v-model="postData.os"
                    name="os",
                    v-validate="",
                    data-vv-as="OS",
                    data-testid="os"
                  )
                    option(v-for="item in options.os" :value="item.value") {{item.label}}
                  p(v-else, data-testid="os") {{getOptionLabelByValue(options.os, postData.os) || '(未選択)'}}

              .column.is-half-mobile.is-full-tablet
                b-field(
                  label="その他"
                  :message="getInputMessage('os_other')"
                  :type="getInputType('os_other')"
                )
                  b-input(
                    v-if="isEdit"
                    v-model="postData.os_other"
                    name="os_other",
                    :maxlength="maxlen_lic.os_other"
                    v-validate="",
                    data-vv-as="その他のOS",
                    placeholder="その他のOSを入力してください"
                    data-testid="os_other"
                  )
                  p(v-else, data-testid="os_other") {{postData.os_other || '(未入力)'}}

        h3.title お客様コードまたは保有ライセンス証書番号

        section.section
          .columns
            .column.is-half
              b-field(
                label="お客様コード"
                :message="getInputMessage('application.customer_code')"
                :type="getInputType('application.customer_code')"
              )
                b-input(
                v-if="isEdit"
                v-model="postData.application.customer_code"
                name="application.customer_code",
                :maxlength="maxlen_app.customer_code"
                v-validate="",
                data-vv-as="お客様コード",
                :placeholder="lang_field.customerCodeExample"
                data-testid="application.customer_code"
                )
                p(v-else, data-testid="application.customer_code") {{postData.application.customer_code || '(未入力)'}}

              app-message.nopdf(type='info')
                notice-customer-code

            .column.is-half
              b-field(
                label="ライセンス証書番号"
                :message="getInputMessage('application.license_no')"
                :type="getInputType('application.license_no')"
              )
                b-input(
                  v-if="isEdit"
                  v-model="postData.application.license_no"
                  name="application.license_no",
                  :maxlength="maxlen_app.license_no"
                  v-validate="",
                  data-vv-as="ライセンス証書番号",
                  :placeholder="lang_field.licenseNoExample"
                  data-testid="application.license_no"
                )
                p(v-else, data-testid="application.license_no") {{postData.application.license_no || '(未入力)'}}

              app-message.nopdf(type='info')
                notice-license-number

        div(v-show="isPartnerApp()" data-testid="section-destination")
          h3.title.required 電子納品先(電子メール納品)

          section.section
            app-message.nopdf(type="warning")
              p エンドユーザー様情報・パートナー様情報に記載された、メールアドレス宛て(1ヶ所)に電子納品されます。

            b-field(
              :message="getInputMessage('delivery_destination')"
              :type="getInputType('delivery_destination')"
            )
              b-select(
                v-if="isEdit"
                placeholder="（選択してください）"
                v-model="postData.delivery_destination"
                name="delivery_destination",
                v-validate="",
                data-vv-as="電子納品先(電子メール納品)",
                data-testid="delivery_destination"
                :required="isPartnerApp()"
              )
                option(v-for="item in options.delivery_destination" :value="item.value") {{item.label}}
              p(v-else, data-testid="delivery_destination") {{getOptionLabelByValue(options.delivery_destination, postData.delivery_destination) || '(未選択)'}}

        h3.title エンドユーザー様情報
        form-user(v-if="nextTicker", v-model="postData.application" prefix="end_")

        //- データインポート時にDOMの描画が間に合わずにvee-validateエラーになるので、v-ifではなくv-showにする
        section.section(v-show="isOptionKeySelected(options.categories, 'neoForSqlBuy', postData.categories)" data-testid="section-english-enduser")
          b-field.required(
            label="法人名または組織名（英文）"
            :message="getInputMessage('org_name_en')"
            :type="getInputType('org_name_en')"
          )
            b-input(
              v-if="isEdit",
              v-model="postData.org_name_en",
              name="org_name_en",
              :required="isOptionKeySelected(options.categories, 'neoForSqlBuy', postData.categories)",
              :maxlength="maxlen_lic.org_name_en",
              v-validate="",
              data-vv-as="法人名または組織名（英文）",
              data-testid="org_name_en"
            )
            p(v-else, data-testid="org_name_en") {{postData.org_name_en}}

          .columns
            .column.is-half
              b-field.required(
                label="郵便番号（英文）"
                :message="getInputMessage('zipcode_en')"
                :type="getInputType('zipcode_en')"
              )
                b-input(
                  v-if="isEdit",
                  v-model="postData.zipcode_en",
                  name="zipcode_en",
                  :required="isOptionKeySelected(options.categories, 'neoForSqlBuy', postData.categories)",
                  :maxlength="maxlen_lic.zipcode_en",
                  v-validate="",
                  data-vv-as="郵便番号（英文）",
                  data-testid="zipcode_en"
                )
                p(v-else, data-testid="zipcode_en") {{postData.zipcode_en}}

          b-field.required(
            label="住所（英文）"
            :message="getInputMessage('address_en')"
            :type="getInputType('address_en')"
          )
            b-input(
              v-if="isEdit",
              v-model="postData.address_en",
              name="address_en",
              :required="isOptionKeySelected(options.categories, 'neoForSqlBuy', postData.categories)",
              :maxlength="maxlen_lic.address_en",
              v-validate="",
              data-vv-as="法人名または組織名（英文）",
              data-testid="address_en"
            )
            p(v-else, data-testid="address_en") {{postData.address_en}}

        template(v-if="isPartnerApp()")
          h3.title エンドユーザー様へ販売されるパートナー様情報
          form-user(v-if="nextTicker", v-model="postData.application" prefix="partner_")

      button-bar(@downloadDataFile="downloadDataFile" @importData="importData")
</template>

<script>
import BaseContent from '@/components/BaseContent'
import ButtonBar from '@/components/apps/com/ButtonBar'
import FormHeader from '@/components/apps/com/FormHeader'
import FormUser from '@/components/apps/com/FormUser'
import NoticeCustomerCode from '@/components/apps/com/NoticeCustomerCode'
import NoticeLicenseNumber from '@/components/apps/com/NoticeLicenseNumber'
import AppMessage from '@/components/AppMessage'
import MixinApplication from '@/mixins/application'
import MixinHandleErrors from '@/mixins/handleErrors'
import { Applications as maxlen_app, AppLicenseSupports as maxlen_lic } from '@/config/maxlengths'
import Util from '@/utils/util'
import { fields as lang_field } from '@/lang/ja_JP'

export default {
  name: 'BuyLicenseAndSupport',
  mixins: [ MixinApplication, MixinHandleErrors ],
  components: {BaseContent, ButtonBar, FormHeader, FormUser, NoticeCustomerCode, NoticeLicenseNumber, AppMessage},
  data () {
    return {
      maxlen_app,
      maxlen_lic,
      lang_field,
      Util,
      postData: {
        application: {
          order_no: '',
          estimate_no: '',
          license_no: '',
          customer_code: ''
        },
        editions: [],
        editions_other: '',
        categories: [],
        categories_other: '',
        support_continue: '',
        service_type: '',
        trial_key_usage_flg: '',
        data_migration_request_flg: '',
        trial_key: '',
        as_neo_license_count: '',
        as_license_no: '',
        add_expenses_category: null,
        add_expenses_license_no: '',
        upd_expenses_category: null,
        upd_expenses_support_service_no: '',
        db: null,
        db_other: '',
        os: null,
        os_other: '',
        delivery_destination: null,
        org_name_en: '',
        zipcode_en: '',
        address_en: '',
      },

      infoIcon: true,
      elEditon: null,

      /**
       * 選択肢の定義
       * options[ここはフィールド名]
       */
      options: {
        editions: [
          {
            key: 'neo',
            label: 'desknet\'s NEO',
            value: 'p'
          },
          {
            key: 'app',
            label: 'AppSuite',
            value: 'q',
            notes: true,
            notesmessage:
              'AppSuiteライセンスを新規・追加購入される際は「AppSuite 明細」の記載をお願いします。'
          },
          {
            key: 'web',
            label: 'ウェブ会議',
            value: 'r'
          },
          {
            key: 'chatLuck',
            label: 'ChatLuck',
            value: 'm'
          },
          {
            key: 'deskCams',
            label: 'desknet\'s CAMS',
            value: 'k'
          },
          {
            key: 'denbun',
            label: 'DenbunPOP/IMAP',
            value: 'l'
          },
          {
            key: 'otherEdition',
            label: 'その他',
            value: 's'
          }
        ],

        categories: [
          {
            key: 'licenseNew',
            label: 'ライセンスの新規購入',
            value: 'a'
          },
          {
            key: 'licenseAdd',
            label: 'ライセンスの追加購入',
            value: 'b'
          },
          {
            key: 'yearSupportBuy',
            label: '年間サポートの購入',
            value: 'o'
          },
          {
            key: 'disDevBuLicenseBuy',
            label: '分散・開発検証・バックアップライセンスの購入',
            value: 'p'
          },
          {
            key: 'chatchange',
            label: 'ChatLuck ルームライセンスからの乗換',
            value: 'd'
          },
          {
            key: 'chatRelayServerLicenseBuy',
            label: 'ChatLuck 中継サーバーライセンスの購入',
            value: 'n'
          },
          {
            key: 'expensesOptionBuy',
            label: '交通費・経費オプションの新規購入',
            notesmessage: '「交通費・経費精算年間ライセンス」を過去に1度でも、ご購入いただいたことがあるお客様は更新ライセンスがご購入対象のため、右側の「交通費・経費オプションの更新」をご選択ください。',
            value: 'i'
          },
          {
            key: 'expensesOptionUpdate',
            label: '交通費・経費オプションの更新',
            notesmessage: '「交通費・経費精算年間ライセンス」の新規ご購入の場合は、左側の「交通費・経費オプションの新規購入」をご選択ください。',
            value: 'j'
          },
          {
            key: 'dndrive',
            label: "desknet'sドライブの購入",
            value: 'r'
          },
          {
            key: 'appSuiteHandsOnSupport',
            label: 'AppSuite伴走支援サービスの購入',
            value: 's',
          },
          {
            key: 'otherCategory',
            label: 'その他',
            value: 'q'
          }
        ],

        // 購入区分詳細 > 年間サポートの購入 > 継続確認
        support_continue: [
          {
            key: 'now_continue',
            label: '現サポート期間満了日の翌月1日から開始する',
            value: '0'
          },
          {
            key: 'order_continue',
            label: '当社ご注文受付日の翌月1日から開始する',
            value: '1'
          }
        ],

        // 購入区分詳細 > AppSuite伴走支援サービスの購入
        service_type: [
          {
            key: 'cloud',
            label: 'クラウド版で利用中または導入検討中',
            value: '0'
          },
          {
            key: 'package',
            label: 'パッケージ版で利用中または導入検討中',
            value: '1'
          },
        ],

        db: [
          {
            key: 'selectMessage',
            label: '（選択してください）',
            value: ''
          },
          {
            key: 'psgrSql16.3',
            label: 'PostgreSQL16.3',
            value: 'p'
          },
          {
            key: 'psgrSql13.3',
            label: 'PostgreSQL13.3',
            value: 'm'
          },
          {
            key: 'psgrSQL96',
            label: 'PostgreSQL9.6',
            value: 'a'
          },
          {
            key: 'SqlServer2022',
            label: 'SQLServer2022',
            value: 'n'
          },
          {
            key: 'SqlServer2019',
            label: 'SQLServer2019',
            value: 'k'
          },
          {
            key: 'SqlServer2016',
            label: 'SQLServer2016',
            value: 'd'
          },
          {
            key: 'SqlServer2012',
            label: 'SQLServer2012',
            value: 'e'
          },
          {
            key: 'oracleDb12cR2',
            label: 'OracleDatabase12cR2',
            value: 'o'
          },
          {
            key: 'oracleDb11gR2',
            label: 'OracleDatabase11gR2',
            value: 'h'
          }
        ],

        os: [
          {
            key: 'selectMessage',
            label: '（選択してください）',
            value: ''
          },
          {
            key: 'winServer2025',
            label: 'Windows Server 2025  (Standard)',
            value: 'x'
          },
          {
            key: 'winServer2022 ',
            label: 'Windows Server 2022  (Standard)',
            value: 'o'
          },
          {
            key: 'winServer2019',
            label: 'Windows Server 2019 (Standard)',
            value: 'l'
          },
          {
            key: 'winServer2016',
            label: 'Windows Server 2016 (Standard)',
            value: 'a'
          },
          {
            key: 'winServer2012R2',
            label: 'Windows Server 2012 R2 (Standard)',
            value: 'b'
          },
          {
            key: 'winServer2012',
            label: 'Windows Server 2012 (Standard)',
            value: 'c'
          },
          {
            key: 'redHatEnLinux10',
            label: 'Linux (x86_64) RedHat Enterprise Linux 10.0',
            value: 'y'
          },
          {
            key: 'redHatEnLinux9',
            label: 'Linux (x86_64) RedHat Enterprise Linux 9.0',
            value: 'p'
          },
          {
            key: 'redHatEnLinux81',
            label: 'Linux (x86_64) RedHat Enterprise Linux 8.1',
            value: 'q'
          },
          {
            key: 'redHatEnLinux72',
            label: 'Linux (x86_64) RedHat Enterprise Linux 7.2',
            value: 'r'
          },
          {
            key: 'redHatEnLinux66',
            label: 'Linux (x86_64) RedHat Enterprise Linux 6.6',
            value: 's'
          },
          {
            key: 'redHatEnLinux63',
            label: 'Linux (x86_64) RedHat Enterprise Linux 6.3',
            value: 't'
          },
          {
            key: 'redHatEnLinux62',
            label: 'Linux (x86_64) RedHat Enterprise Linux 6.2',
            value: 'u'
          },
          {
            key: 'almaLinux10',
            label: 'AlmaLinux 10.0',
            value: 'z'
          },
          {
            key: 'almaLinux92',
            label: 'AlmaLinux 9.2',
            value: 'v'
          },
          {
            key: 'almaLinux85',
            label: 'AlmaLinux 8.5',
            value: 'w'
          },
        ],

        add_expenses_category: [
          {
            key: 'basicLicenseWith',
            label: '基本ライセンスと同時に購入',
            value: '7'
          },
          {
            key: 'ysJoining',
            label: '年間サポート加入中(オプション新規購入)',
            value: '8',
          },
          {
            key: 'ysWith',
            label: '年間サポートと同時にご購入(オプション新規購入)',
            value: '9',
          }
        ],

        upd_expenses_category: [
          {
            key: 'ysJoining',
            label: '年間サポート加入中(オプション更新購入)',
            value: '3',
          },
          {
            key: 'ysWith',
            label: '年間サポートと同時にご購入',
            value: '4',
          }
        ],

        delivery_destination: [
          {
            key: 'deliveryEnduser',
            label: 'エンドユーザー様',
            value: '0'
          },
          {
            key: 'deliveryPartner',
            label: 'エンドユーザー様へ販売されるパートナー様',
            value: '1'
          }
        ]
      },

      // PDF作成処理失敗によるエラーメッセージ
      appErrorMessage: '',
      appInfoMessage: ''
    }
  },
  methods: {
    showAppSuiteSection () {
      return (
        this.isOptionKeySelected(this.options.editions, 'app', this.postData.editions)
      ) && (
        this.isOptionKeySelected(this.options.categories, 'licenseNew', this.postData.categories) ||
        this.isOptionKeySelected(this.options.categories, 'licenseAdd', this.postData.categories)
      )
    },

    showAddExpensesSection () {
      return this.isOptionKeySelected(this.options.categories, 'expensesOptionBuy', this.postData.categories)
    },

    showUpdExpensesSection () {
      return this.isOptionKeySelected(this.options.categories, 'expensesOptionUpdate', this.postData.categories)
    },

    showDbPreSection () {
      return this.isOptionKeySelected(this.options.editions, 'deskDbPre', this.postData.editions)
    },

    showServerSection () {
      return (
        this.isOptionKeySelected(this.options.editions, 'neo', this.postData.editions) ||
        this.isOptionKeySelected(this.options.editions, 'app', this.postData.editions) ||
        this.isOptionKeySelected(this.options.editions, 'web', this.postData.editions)
      )
    },

    app_getSubmitData () {
      // 共通処理
      let submitData = this.getSubmitData()

      // 個別処理
      submitData.categories = submitData.categories.join(',')
      submitData.editions = submitData.editions.join(',')

      return submitData
    },

    /**
     * 指定した購入区分詳細を取得する
     */
    getCategory (key) {
      return this.options.categories.find(item => item.key === key)
    },

    app_validationCheck () {
      if (!this.postData.editions.length) {
        // エラー位置までスクロールする
        Util.scrollToEl(document.getElementById('editions'))
        return false
      }
      if (!this.postData.categories.length) {
        // エラー位置までスクロールする
        Util.scrollToEl(document.getElementById('categories'))
        return false
      }
      return true
    },

    app_setImportData (importData) {
      // 共通処理
      this.setImportData(importData, this.postData)

      // 購入ライセンスエディション
      if ('editions' in importData) {
        if (importData.editions.length > 0) {
          this.postData.editions = importData.editions.split(',')
        }
        // 配列以外のものがインポートされていた場合、空配列で上書きする
        if (!Array.isArray(this.postData.editions)) {
          this.postData.editions = []
        }
      }

      // 購入区分詳細
      if ('categories' in importData) {
        if (importData.categories.length > 0) {
          this.postData.categories = importData.categories.split(',')
        }
        // 配列以外のものがインポートされていた場合、空配列で上書きする
        if (!Array.isArray(this.postData.categories)) {
          this.postData.categories = []
        }
      }

      // desknet'sドライブを購入しない場合は、関連する入力値をクリアする
      if (!this.isOptionKeySelected(this.options.categories, 'dndrive', this.postData.categories)) {
        this.postData.trial_key_usage_flg = ''
        this.postData.data_migration_request_flg = ''
        this.postData.trial_key = ''
      }
      else {
        // インポートデータに項目がない場合は、現在の入力値が残らないようにクリアする
        if (!('trial_key_usage_flg' in importData)) {
          this.postData.trial_key_usage_flg = ''
        }
        if (!('data_migration_request_flg' in importData)) {
          this.postData.data_migration_request_flg = ''
        }
        if (!('trial_key' in importData)) {
          this.postData.trial_key = ''
        }
      }
    },

    /**
     * desknet'sドライブ トライアルの利用状況変更時に、依存する入力値をリセットする
     *
     * @param {string} value desknet'sドライブ トライアル利用フラグ
     * @returns {void}
     */
    resetDndriveMigration (value) {
      if (value !== '1') {
        // トライアルを利用しない場合は、データ引き継ぎ希望をクリアする
        this.postData.data_migration_request_flg = ''
        this.postData.trial_key = ''
      }
    },

    /**
     * 本番環境へのデータ引き継ぎ希望を変更した際に、依存するトライアルキーを整合させる
     *
     * @param {string} value 本番環境へのデータ引き継ぎ希望フラグ
     * @returns {void}
     */
    resetDndriveTrialKey (value) {
      if (value !== '1') {
        // データ引き継ぎを希望しない場合はトライアルキーをクリアする
        this.postData.trial_key = ''
      }
    },

    /**
     * 購入区分変更時に、desknet'sドライブの入力値を整合させる
     *
     * @param {string} key 変更された購入区分のキー
     * @returns {void}
     */
    handleCategoryChange (key) {
      if (key === 'dndrive' && !this.isOptionKeySelected(this.options.categories, 'dndrive', this.postData.categories)) {
        // desknet'sドライブの購入を取り消した場合は、関連する入力値をクリアする
        this.postData.trial_key_usage_flg = ''
        this.postData.data_migration_request_flg = ''
        this.postData.trial_key = ''
      }
    }
  },
  created () {
    this.mode = 'edit'
    this.postData.application = Object.assign(this.postData.application, this.postData__application)
    this.postData.application.app_code = 'lic'
  }
}
</script>

<style scoped>
.continue {
  margin-left: 1.75rem;
  padding-bottom: 0.75rem;
}

.continue .block {
  margin-top: 0.5rem;
  margin-left: 1.75rem;
  margin-bottom: 0rem;
}

.continue .block .caution{
  font-size: .75rem;
}

.dndrive-confirm-answer {
  margin-left: 1.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/BuyLicenseAndSupport.vue